import * as webvtt from 'node-webvtt';

export const convertWebvttToJson = (webvttContent) => {
  try {
    const jsonContent = webvtt.parse(webvttContent);
    return jsonContent;
  } catch (error) {
    console.error('Error converting WebVTT to JSON', error);
    return { valid: false, error: error.message };
  }
};

export const convertJsonToWebvtt = (jsonContent) => {
  try {
    const webvttContent = webvtt.compile(jsonContent);
    return webvttContent;
  } catch (error) {
    console.error('Error converting JSON to WebVTT', error);
    return null;
  }
};
